export default {
  // Navigation
  'nav.customize': 'Customize',
  'nav.gallery': 'Gallery',
  'nav.etsy_shop': 'Etsy Shop',
  
  // Hero Section
  'hero.title': 'Create unforgettable moments',
  'hero.subtitle': 'Personalize gift boxes, piñatas, t-shirts and 3D engravings. Design your perfect product and visualize it in real-time.',
  'hero.cta_customize': 'Start Customizing',
  'hero.cta_gallery': 'View Gallery',
  'hero.cta_etsy': 'Shop on Etsy',
  'hero.badge': 'Handmade Party Supplies in NYC',
  'hero.stats_customers': 'Happy Customers',
  'hero.stats_handmade': 'Handmade',
  'hero.stats_support': 'Support',
  
  // Home Page
  'home.categories_title': 'Shop by Category',
  'home.categories_subtitle': 'Explore our collection of handmade party supplies',
  'home.why_choose_us': 'Why Choose Us',
  'home.why_subtitle': 'We create unique party supplies with love and dedication',
  'home.feature_1_title': '100% Customizable',
  'home.feature_1_desc': 'Design your perfect party supplies with our easy customization tools',
  'home.feature_2_title': 'Handmade with Love',
  'home.feature_2_desc': 'Each item is carefully crafted by hand with attention to detail',
  'home.feature_3_title': 'Fast Shipping',
  'home.feature_3_desc': 'Quick delivery to make your celebration unforgettable',
  'home.cta_title': 'Ready to Make Your Party Special?',
  'home.cta_subtitle': 'Browse our collection and order your custom party supplies today',
  'home.cta_contact': 'Contact Us',
  
  // Categories
  'categories.title': 'Shop by Category',
  'categories.subtitle': 'Explore our collection of handmade party supplies',
  'categories.products': 'products',
  'categories.explore': 'Explore',
  
  'categories.pinatas': 'Piñatas',
  'categories.pinatas_desc': 'Custom star and number piñatas with vibrant colors',
  'categories.banners': 'Party Banners',
  'categories.banners_desc': 'Personalized banners for any celebration',
  'categories.stickers': 'Custom Stickers',
  'categories.stickers_desc': 'Custom sticker sheets (4x7 inches)',
  'categories.tshirts': 'Custom T-Shirts',
  'categories.tshirts_desc': 'Personalized t-shirts with your design',
  'categories.favor_boxes': 'Favor Boxes',
  'categories.favor_boxes_desc': 'Beautiful boxes for party favors',
  'categories.engraving': '3D Engraving',
  'categories.engraving_desc': 'Custom laser-cut wooden decorations',
  
  // Products
  'products.featured_title': 'Popular Products',
  'products.featured_subtitle': 'Our most loved creations',
  'products.view_all': 'View All',
  'products.star_pinata': 'Star Piñata',
  'products.number_5_pinata': 'Number 5 Piñata',
  'products.custom_banner': 'Custom Banner',
  'products.sticker_sheet': 'Sticker Sheet',
  
  // Features
  'features.custom_title': '100% Customizable',
  'features.custom_desc': 'Design your perfect party supplies with our easy customization tools',
  'features.handmade_title': 'Handmade with Love',
  'features.handmade_desc': 'Each item is carefully crafted by hand with attention to detail',
  'features.shipping_title': 'Fast Shipping',
  'features.shipping_desc': 'Quick delivery to make your celebration unforgettable',
  
  // Footer
  'footer.description': 'Handmade party supplies in NYC',
  'footer.quick_links': 'Quick Links',
  'footer.contact': 'Contact',
  'footer.tagline': 'Handmade party supplies in NYC',
  'footer.shop': 'Shop',
  'footer.customize': 'Customize',
  'footer.gallery': 'Gallery',
  'footer.etsy': 'Etsy Store',
  'footer.categories': 'Categories',
  'footer.connect': 'Connect',
  'footer.rights': 'All rights reserved.',
  
  // Customize Page
  'customize.title': 'Customize Your Product',
  'customize.select_category': 'Select a category to begin',
  'customize.select_product': 'Choose Your Product',
  'customize.select_product_desc': 'Select the product you want to customize',
  'customize.back': 'Back',
  'customize.home': 'Home',
  'customize.no_products': 'No products available',
  'customize.no_products_desc': 'This category doesn\'t have products yet.',
  'customize.customizing': 'Customizing',
  'customize.design_desc': 'Design your perfect product with our 3D customization tool',
  'customize.in_development': 'Customizer in Development',
  'customize.in_development_desc': 'The customizer for this product will be available soon.',
  'customize.view_etsy': 'View on Etsy',
  
  // Gallery
  'gallery.title': 'Our Gallery',
  'gallery.subtitle': 'Browse our collection of handmade creations',
  'gallery.all': 'All',
  'gallery.no_products': 'No products found',
  'gallery.no_products_desc': 'Try selecting a different category.',
  'gallery.loading': 'Loading...',
};
